import './PaymentAccountAgreement.scss';

const PaymentAccountAgreement = () => {
    const handleAccept = () => {
        console.log('Agreement accepted');
    };

    return (
        <main className="payment-account-agreement">
            <div className="payment-account-agreement__container">
                <div className="payment-account-agreement__content">
                    <iframe
                        src="/muqavile.html"
                        title="Ödəniş hesabı müqaviləsi"
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '100vh',
                            border: 'none',
                            background: '#fff',
                        }}
                    />
                </div>

                <button
                    type="button"
                    onClick={handleAccept}
                    className="payment-account-agreement__button"
                >
                    Qəbul edirəm
                </button>
            </div>
        </main>
    );
};

export default PaymentAccountAgreement;
